import loadable from '@loadable/component';

export const OrgDashboardCreateVolopPageContainerLoadable = loadable(
  () => import('./OrgDashboardCreateVolopPageContainer'),
  {
    resolveComponent: (module) => module.OrgDashboardCreateVolopPageContainer,
    ssr: false,
  },
);
